const KEY = "ccpc_visit_source";

const describe = () => {
  const q = new URLSearchParams(window.location.search);
  const utm = q.get("utm_source");
  if (utm) return [utm, q.get("utm_medium"), q.get("utm_campaign")].filter(Boolean).join(" / ");
  if (q.get("gclid")) return "Google Ads";
  if (q.get("fbclid")) return "Facebook / Instagram link";
  let host = "";
  try { host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "") : ""; } catch { host = ""; }
  if (!host || host === window.location.hostname.replace(/^www\./, "")) return null;
  if (/google\./.test(host)) return "Google search";
  if (/bing\.|duckduckgo|yahoo\./.test(host)) return `Search (${host})`;
  if (/facebook|instagram|linkedin|t\.co$|twitter|x\.com/.test(host)) return `Social media (${host})`;
  if (/chatgpt|openai|perplexity|claude|gemini|copilot/.test(host)) return `AI assistant (${host})`;
  return `Link from ${host}`;
};

// First-touch source: kept in memory; saved on the device (90 days) only with analytics consent.
let current = null;

export const captureVisitSource = () => {
  current = { source: describe() || "Direct (typed address or bookmark)", landing: window.location.pathname, at: Date.now() };
};

const saved = () => {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || "null");
    return s && Date.now() - s.at < 90 * 864e5 ? s : null;
  } catch { return null; }
};

export const persistVisitSource = (allowed) => {
  try {
    if (!allowed) localStorage.removeItem(KEY);
    else if (!saved() && current) localStorage.setItem(KEY, JSON.stringify(current));
  } catch { /* storage unavailable */ }
};

export const getVisitSource = () => {
  const s = saved() || current;
  return s ? `${s.source} - first page ${s.landing}`.slice(0, 300) : null;
};

export const HEARD_ABOUT = [
  "Google search", "My GP or another doctor", "Friend or family", "Social media",
  "NHS clinic / hospital", "AI assistant (e.g. ChatGPT)", "I've been here before", "Other",
];
